import { createContext, Dispatch } from "react";
import { Action } from "./actions";

// STATE
export interface MyAccountState {
    initialized: boolean,
    baseUrl: string,
    defaultSuggestedDonationAmounts: string,
    email: string,
    emailConfirmed: boolean,
    pacDonationsFeatureEnabled: boolean,
    pageClosingEnabled: boolean,
    paymentPageCheckboxEnabled: boolean,
    politicalPartiesEnabled: boolean,
    recipients: Recipient[],
    subscriptionsEnabled: boolean,
    contextualHelpClickEnabled: boolean,
    eventPagesEnabled: boolean,
    timeZone: string
}

// ToDo recipientId vs identifier
export interface Recipient {
    availableToFundraisers: boolean;
    id: string;
    identifier: string;
    displayName: string;
    district: string;
    office: string;
    politicalParty: string;
    status: string;
}

// INITIAL STATE
export const initialMyPageState: MyAccountState = {
    initialized: false,
    baseUrl: "",
    defaultSuggestedDonationAmounts: "",
    email: "",
    emailConfirmed: false,
    pacDonationsFeatureEnabled: false,
    pageClosingEnabled: false,
    paymentPageCheckboxEnabled: false,
    politicalPartiesEnabled: false,
    recipients: [],
    subscriptionsEnabled: false,
    contextualHelpClickEnabled: false,
    eventPagesEnabled: false,
    timeZone: ""
}

// CONTEXTS
let initialMyAccountStateContext = { state: initialMyPageState, dispatch: (action: Action) => { } }
export const MyAccountStateContext = createContext<{ state: MyAccountState, dispatch: Dispatch<Action> }>(initialMyAccountStateContext);